import { Directive } from '@angular/core';

/**
 * Directive that marks the scrollable dialog content area.
 *
 * Usage: `<div appDialogContent>...</div>`
 */
@Directive({
  selector: '[appDialogContent], [app-dialog-content], app-dialog-content',
  host: {
    class: 'dialog__content',
  },
})
export class DialogContentDirective {}
